<template>
  <div class="h-dialogContainer">
    <div class="row">
      <div class="col-sm-6">
        <div class="h-borderBox height-260">
          <div class="h-borderTree-pm-content">
            <NeTreeForNoRealTaskCreate ref="NeTreeForNoRealTaskCreate" @measureTreeShowTypeChange="measureTreeShowTypeChange"></NeTreeForNoRealTaskCreate>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="h-borderBox height-260">
          <div class="h-borderTree-pm-content">
            <MeasureTreeForNoRealTaskCreate ref="MeasureTreeForNoRealTaskCreate" :measureTreeShowType="measureTreeShowType"></MeasureTreeForNoRealTaskCreate>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="h-btnBox">
          <ejs-button id="btnFive1" iconCss="icon hero-icon hero-icon-double-down" cssClass="h-btn-put" :isPrimary="true" v-on:click.native="addCounters">{{$t('Pm.addToFollow')}}</ejs-button>
        </div>
      </div>
    </div>
    <div class="row">
      <MeasureListForNoRealTaskCreate id="MeasureListForNoRealTaskCreate" ref="MeasureListForNoRealTaskCreate"></MeasureListForNoRealTaskCreate>
    </div>
  </div>
</template>

<script>
  import NeTreeForNoRealTaskCreate from '../tree/NeTreeForNoRealTaskCreate';
  import MeasureTreeForNoRealTaskCreate from '../tree/MeasureTreeForNoRealTaskCreate';
  import MeasureListForNoRealTaskCreate from "../MeasureListForNoRealTaskCreate";
  import {EventBus} from "../../../../../../plugins/eventBus";

  export default {
    name: 'CreateNoRealTaskDialog2',
    props: [
      'paramsOfNoRealTaskCreateDialog1'
    ],
    components: {
      NeTreeForNoRealTaskCreate,
      MeasureTreeForNoRealTaskCreate,
      MeasureListForNoRealTaskCreate
    },
    data() {
      return {
        measureTreeShowType: 2,
        treeGridList: [],
        paramsOfNoRealTaskCreateDialog2: {
          neId: '',
          moIdNum: 0,
          moIdList: [],
          counterIdNum: 0,
          counterIdList: []
        }
      }
    },
    methods: {
      measureTreeShowTypeChange(msg) {
        this.measureTreeShowType = msg;
      },
      addCounters(){
        this.paramsOfNoRealTaskCreateDialog2.counterIdList = [];
        this.treeGridList = [];
        const NeTreeForCreate = this.$refs.NeTreeForNoRealTaskCreate.$refs.neTreeForNoRealTaskCreate;
        const selectedNodesOfNeTree = NeTreeForCreate.ej2Instances.selectedNodes;
        const neSelect = NeTreeForCreate.getTreeData(selectedNodesOfNeTree[0])[0];

        // 过滤树中的非网元节点
        if (!neSelect || !neSelect.attributes || !neSelect.attributes.neId) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectResource') });
          return;
        }

        this.paramsOfNoRealTaskCreateDialog2.neId = neSelect.attributes.neId;

        // 获取指标树中选中的指标信息
        let counterObj = null;
        let measureObj = null;
        let measureObjCodeList = [];
        let MeasureObjTreeForCreate = this.$refs.MeasureTreeForNoRealTaskCreate.$refs.MeasureTreeForNoRealCreate;
        const checkNodesOfMeasureObjTree = MeasureObjTreeForCreate.getAllCheckedNodes();

        // 过滤树中的非网测量对象节点
        if (checkNodesOfMeasureObjTree.length == 0) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMOplease') });
          return;
        }
        for (let i = 0; i < checkNodesOfMeasureObjTree.length; i++) {
          // 获取选中节点信息
          const nodeChecked = MeasureObjTreeForCreate.getTreeData(checkNodesOfMeasureObjTree[i])[0];

          // 筛除掉父级非测量对象节点
          if (nodeChecked.children.length > 0 || nodeChecked.attributes.measureObjTypeCode != null) {
            continue;
          }

          // 将选中的测量对象节点信息存入measureObj中
          counterObj = {
            measureObjName: (this._i18n.locale === 'zh') ? nodeChecked.attributes.measureObjNameCH : nodeChecked.attributes.measureObjNameOT,
            counterName: (this._i18n.locale === 'zh') ? nodeChecked.attributes.counterNameCH : nodeChecked.attributes.counterNameOT,
            id: nodeChecked.attributes.counterCode,
            parentItem: nodeChecked.attributes.measureObjCode,
            isParent:false
          }
          this.paramsOfNoRealTaskCreateDialog2.counterIdList.push(nodeChecked.attributes.counterCode);

          measureObj = {
            measureObjName: (this._i18n.locale === 'zh') ? nodeChecked.attributes.measureObjNameCH : nodeChecked.attributes.measureObjNameOT,
            counterName: '',
            id: nodeChecked.attributes.measureObjCode,
            parentItem: null,
            isParent:true
          }

          if(measureObjCodeList.indexOf(nodeChecked.attributes.measureObjCode) == -1){
            this.treeGridList.push({
              measureObjName: (this._i18n.locale === 'zh') ? nodeChecked.attributes.measureObjNameCH : nodeChecked.attributes.measureObjNameOT,
              counterName: '',
              id: nodeChecked.attributes.measureObjCode,
              parentItem: null,
              isParent:true
            });
            measureObjCodeList.push(nodeChecked.attributes.measureObjCode);
            this.paramsOfNoRealTaskCreateDialog2.moIdList.push(nodeChecked.attributes.measureObjCode);
          }

          // 将measureObj存入treeGridList中作为treeGrid的子节点
          this.treeGridList.push(counterObj);
          counterObj = null;
        }
        // 更新加载表格的数据源
        this.paramsOfNoRealTaskCreateDialog2.moIdNum = this.paramsOfNoRealTaskCreateDialog2.moIdList.length;
        this.paramsOfNoRealTaskCreateDialog2.counterIdNum = this.paramsOfNoRealTaskCreateDialog2.counterIdList.length;
        this.$refs.MeasureListForNoRealTaskCreate.dataOfNoRealTaskCreateList = this.treeGridList;
      }
    }
  };
</script>

<style>
</style>
